// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/button/index.scss
// module id = 247
// module chunks = 0